import { render, staticRenderFns } from "./tzEnterpriseNews.vue?vue&type=template&id=d0c66f68&"
import script from "./tzEnterpriseNews.vue?vue&type=script&lang=js&"
export * from "./tzEnterpriseNews.vue?vue&type=script&lang=js&"
import style0 from "./tzEnterpriseNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports